var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"float d-flex justify-content-end"},[_c('button',{staticClass:"btn btn-float btn-rounded btn-icon btn-secondary",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('i',{staticClass:"fa fa-level-up"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }